import './../css/mk-brand.css';
import config from '../config';
import {VaultComponent} from '../components/VaultComponent';
import CustomizedVaultCSS from '../css/diamond-vault.css';
import {useState} from "react";

function StakingPage() {
  const [showWarning, setShowWarning] = useState(true);
  return (
    <div id="staking-page" className="panel">
      {
        config.IS_STAKING_ACTIVE ?
          <>
            <link rel="stylesheet" href={CustomizedVaultCSS} />
            <div className={`bg-brand-hover text-brand-text p-4 rounded-lg m-2 ${showWarning ? 'block' : 'hidden'}`}>
                <div
                    className="bg-zinc-500 px-1 pull-right cursor-pointer rounded ml-2"
                    onClick={()=> {setShowWarning(false);}}
                >X</div>
              New to staking? Remember, if you select a LOCK based staking plan you can NOT unstake your chefs until the period expires.
            </div>
            <VaultComponent vaultPath="metakitchen" />
          </>
            :
          <div>
            Staking is not currently active. Please refer to our discord channel for more information.
          </div>
      }
    </div>
  );
}

export default StakingPage;
